import { useState, useEffect } from "react";
import FilterContext from "./Context";
import i18n from "i18next"; // Getting eslint error Module imports itself.
import zhCN from "rsuite/locales/zh_CN";
import enUS from "rsuite/locales/en_US";
import {CONSTANTS} from '../Api/Constants'
import {factoryStartEndTime} from '../Hooks/Common'

const FilterProvider = ({ children }) => {
  const [filterQuery, SetFilterQuery] = useState(null);
  const [ isLive, SetIsLive ] = useState(false);
  const [ selectedMenu, SetSelectedMenu ] = useState('');
  const [language, SetLanguage] = useState(
    localStorage.getItem("i18nextLng") && null
  );

  const languageCodes = [
    {
      id: "en",
      value: enUS,
    },
    {
      id: "zh",
      value: zhCN,
    },
  ];

  const ChangeLanguage = (languageCode) => {
    let language = languageCodes[languageCode - 1].id;
    localStorage.setItem("i18nextLng", language);
    i18n.changeLanguage(language);
    SetLanguage(language);
  };

  const GenerateFilters = (filterRequestQuery) => {
    SetFilterQuery({
      filterRequestQuery: filterRequestQuery,
      GenerateFilters: GenerateFilters,
      ChangeLanguage: ChangeLanguage,
      language: language ? language : localStorage.getItem("i18nextLng"),
    });
  };

  useEffect(() => {

    if(filterQuery === null) {
      let selectedMenu = localStorage.getItem('currentMenu');
      let fset = factoryStartEndTime()
      let startDate = fset.startTs
      let endDate = fset.endTs

      let filterRequestQuery = {
        factory: "2",
        lines: "2",
        shift: "",
        startTs: startDate,
        endTs: endDate,
        isLive: true,
      };
      if(selectedMenu !== undefined || selectedMenu !== null ) {
        filterRequestQuery.selectedMenu =  selectedMenu;
      }
      
      GenerateFilters(filterRequestQuery);
    }
  }, []);

  return (
    <>
      {filterQuery && (
        <FilterContext.Provider value={filterQuery}>
          {children}
        </FilterContext.Provider>
      )}
    </>
  );
};

export default FilterProvider;
